import { css } from 'styled-components';
export default {
    apparat: {
        light: css `
      font-family: 'Apparat', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'Apparat', sans-serif;
      font-style: italic;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'Apparat', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'Apparat', sans-serif;
      font-style: italic;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'Apparat', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'Apparat', sans-serif;
      font-style: italic;
      font-weight: 500;
    `,
        semiBold: css `
      font-family: 'Apparat', sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        semiBoldItalic: css `
      font-family: 'Apparat', sans-serif;
      font-style: italic;
      font-weight: 600;
    `,
        bold: css `
      font-family: 'Apparat', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'Apparat', sans-serif;
      font-style: italic;
      font-weight: 700;
    `,
    },
    lato: {
        light: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-weight: 300;
      font-style: italic;
    `,
        regular: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-weight: 400;
      font-style: italic;
    `,
        medium: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-weight: 500;
      font-style: italic;
    `,
        semiBold: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-style: normal;
      font-weight: 600;
    `,
        semiBoldItalic: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-weight: 600;
      font-style: italic;
    `,
        bold: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'LatoWeb', 'Trebuchet MS', Helvetica, sans-serif;
      font-weight: 700;
      font-style: italic;
    `,
    },
    sourceSerifPro: {
        regular: css `
      font-family: 'source-serif-pro', 'Times New Roman', Times, serif;
      font-style: normal;
      font-weight: 400;
    `,
    },
};
